<template lang="pug">
  #statistics
    Header
    v-container
      v-row.py-3(flex justify="center")
        v-tabs(fixed-tabs)
          v-tab(v-for="(section, index) in sections" :key="index" v-on:click="setTab(section, index)" v-model="activeTabIndex")
            p.bold.tab-text {{ section.text }}
          v-tab-item(v-for="(section, index) in sections" :key="section.value" v-bind:class="`tab-item${index}`")
            .mt-4.py-3(:id="'downloadable' + index")
              v-row(d-block)
                v-col.summary-box.my-0.pa-2(xs=10 offset-xs=1 d-flex)
                  p.black-text.bold Total de casos documentados: 
                    span.bolder.main-text &nbsp;{{ reports.length }}
                //v-flex.summary-box.my-0.pa-2(xs10 offset-xs1 d-flex)
                  v-flex(xs4)
                    p.bold Total de asesorías atendidas:
                      span.dark-text &nbsp;{{ reports.length }}
                  v-flex(xs4)
                    p.bold Total de tiempo invertido:
                      span.dark-text &nbsp;{{ totalHours }}h {{ totalMinutes }}' 
                  v-flex(xs4)
                    p.bold Promedio de tiempo por asesoría:
                      span.dark-text &nbsp;{{ averageHours }}h {{averageMinutes.toFixed(2) }}'
              v-row.chart-box.pa-4(d-flex)
                v-col(xs=2 sm=3)
                  v-btn-toggle(v-model="activeOption" )
                    v-btn.chart-btn(v-for="(option, i) in options[index]" :key="i" @click="setData(option,i)") {{option.text}}
                v-col(xs=10 sm=9 v-bind:class="['chart-' + index.toString()]")
                  v-row.switch.mt-3.mb-5.pb-5(d-flex justify="center")
                    p.mr-2 Tablas
                    v-switch(
                      v-model="viewChart"
                      color="#752c7d"
                      hide-details=true
                      class="test"
                    )
                    p Gráficas
                  v-row(d-flex justify="center")
                    svg(width="600px" height="300px" v-if="viewChart")
                    v-data-table.ml-5(
                      v-if="!viewChart"
                      :headers="headers"
                      :items="dataset"
                      hide-default-footer
                    )
                      template(v-slot:item="{ item }")
                        tr
                          td {{ item.key }}
                          td {{ item.value }}
                  v-row(d-flex justify="center")
                    v-radio-group(
                      v-model="chartUnit"
                      row
                      v-if="viewChart"
                      
                    )
                      v-radio( label="Total" value="total" :color='radioColor')
                      v-radio( label="Porcentaje" value="percentage" :color='radioColor')
      
      v-container
        v-row.py-3(justify="end")
          v-btn.mx-2.border-btn.bold.black-text.bold(outlined @click="downloadChart()") Descargar gráfico
        
</template>
<script>
import Header from "@/components/Header.vue";
import * as d3 from "d3";
import * as html2canvas from "html2canvas";
import chartModule from "@/services/dcbox.js";

export default {
  name: "Statistics",
  components: {
    Header
  },
  data() {
    return {
      headers: [
        { text: "Categoría", value: "key" },
        { text: "Total", value: "value" }
      ],
      viewChart: true,
      chartUnit: "total",
      sections: [
        {
          text: "Sobre la víctima",
          value: "victimData"
        },
        {
          text: "Sobre los perpetradores",
          value: "perpetrators"
        },
        {
          text: "Sobre acciones realizadas",
          value: "policeReports"
        },
        {
          text: "Sobre seguimiento",
          value: "tracing"
        },
        {
          text: "Datos socioeconómicos",
          value: "socioec"
        }
      ],
      options: [
        [
          {
            text: "Municipios",
            value: "disappearanceMun"
          },
          {
            text: "Sexo",
            value: "sex"
          },
          {
            text: "Edad",
            value: "disappearanceAge"
          },
          {
            text: "Año",
            value: "disappearanceDate"
          }
        ],
        [
          {
            text: "Identificación",
            value: "perpetratorsIdentified"
          },
          {
            text: "Tipo de victimario",
            value: "perpetratorType"
          },
          {
            text: "Portación de armas",
            value: "noticeWeapons"
          }
        ],
        [
          {
            text: "Carpetas o reportes",
            value: "reportNumConfirm"
          },
          {
            text: "Autoridad",
            value: "appealedAuthority"
          }
        ],
        [
          {
            text: "Estatus de localización",
            value: "victimStatus"
          },
          {
            text: "Año de ubicación (Localizado con vida)",
            value: "locationDate"
          },
          {
            text: "Año de localización de restos (Localizado sin vida)",
            value: "bodyLocationDate"
          }
        ],
        [
          {
            text: "Estado civil",
            value: "status"
          },
          {
            text: "Vivienda",
            value: "livingPlace"
          },
          {
            text: "Calidad de víctima",
            value: "condition"
          },
          {
            text: "Número de hijos y dependientes económicos",
            value: "economicDependents"
          }

        ]
      ],
      activeTabIndex: 0,
      activeOption: 0,
      activeTab: {
       text: "Sobre la víctima",
       value: "victimData"
      },
      colors: ["#6b3173", "#93599a", "#916596", "#bb99bf", "#b594ba"],
      totalHours: 0,
      totalMinutes: 0,
      averageHours: 0,
      averageMinutes: 0,
      dataset: [],
      percentageData: [],
      radioColor: "rgba(107, 49, 115,1)"
      
    };
  },
  computed: {
    perpetratorTypes() {
    const types = []
    this.$store.state.reports.length == 0 ? this.$store.state.reports : this.$store.state.reports.map(el => {
      if (el.narrative.perpetrators.perpetratorType == "undefined" || el.narrative.perpetrators.perpetratorType == "null" || el.narrative.perpetrators.perpetratorType == "") el.narrative.perpetrators.perpetratorType = "Sin datos";
        types.push(el.narrative.perpetrators.perpetratorType)
    })
    const flatTypes = types.flat();
    const processed = flatTypes.map(perpetratorType => ({ perpetratorType }))
      return processed;
},
  policeActions() {
    // more than one action per report
    const actions =  []
    this.$store.state.reports.length == 0 ? this.$store.state.reports : this.$store.state.reports.forEach(el => {  
        actions.push(el.narrative.policeReports);      
      });

    const policeActions = actions.reduce((acc, val) => acc.concat(val),[]);
    const policeActionsProcessed =  policeActions.map(el => {
      
      const report = el.reportNumConfirm
      let reportProcessed = el.reportNumConfirm.name
      el.reportNumConfirm = reportProcessed 

      return el
    })
    return policeActionsProcessed
  },
    reports() {
      const processed = this.$store.state.reports.length == 0 ? this.$store.state.reports : this.$store.state.reports.map(el => {
        // Keep only year of dissapearenceDate && locationDate
        if (el.victimData.disappearanceDate)
                el.victimData.disappearanceDate =
                  el.victimData.disappearanceDate.year;
          

        if (el.narrative.tracing.bodyLocationDate)
          el.narrative.tracing.bodyLocationDate = new Date(
            el.narrative.tracing.bodyLocationDate
          ).getFullYear();

        if (el.narrative.tracing.locationDate)
          el.narrative.tracing.locationDate = new Date(
            el.narrative.tracing.locationDate
          ).getFullYear();

        const sex = el.victimData.sex;
        let sexProcessed = el.victimData.sex.name
        el.victimData.sex = sexProcessed

        const perpIdentified = el.narrative.perpetrators.perpetratorsIdentified;
        if (perpIdentified) {
          let perpIdentifiedProcessed = el.narrative.perpetrators.perpetratorsIdentified.name
          el.narrative.perpetrators.perpetratorsIdentified = perpIdentifiedProcessed
        }

        const weapon = el.narrative.perpetrators.noticeWeapons;
        if (weapon) {
          let weaponProcessed = el.narrative.perpetrators.noticeWeapons.name
          el.narrative.perpetrators.noticeWeapons = weaponProcessed
        }


        if (el.socioec) {
          const civilStatus = el.socioec.disappearedPerson.status
          let civilStatusProcessed = el.socioec.disappearedPerson.status.name
          el.socioec.disappearedPerson.status = civilStatusProcessed

          const livingPlace = el.socioec.disappearedPerson.livingPlace
          let livingPlaceProcessed = el.socioec.disappearedPerson.livingPlace
          el.socioec.disappearedPerson.livingPlace = livingPlaceProcessed

          const condition = el.socioec.disappearedPerson.condition.isRegisteredCEAV
          let conditionProcessed = el.socioec.disappearedPerson.condition.isRegisteredCEAV.name
          el.socioec.disappearedPerson.condition.isRegisteredCEAV = conditionProcessed
        }

        const location = el.narrative.tracing.victimStatus;
        let locationProcessed = el.narrative.tracing.victimStatus.name
        el.narrative.tracing.victimStatus = locationProcessed

        return el;
      });
      
      return processed;
    }
  },
  watch: {
    viewChart: function(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.draw(this.activeTabIndex);
        }, 50);
      }
    },
    chartUnit() {
      setTimeout(() => {
          this.draw(this.activeTabIndex);
        }, 50);
    }
  },
  methods: {
    setTab(section, index) {
      this.activeTab = section;
      this.activeTabIndex = index;
      this.activeOption = 0;
      this.setData();
    },
    async draw(which) {
      d3.selectAll("svg").selectAll('*').remove();
      const svg = d3.select(".chart-" + which + " svg");
      const width = svg.attr("width").replace("px", "");
      const height = svg.attr("height").replace("px", "");

      const config = {
        size: {
          width: width,
          height: height,
          margin: {
            left: 60,
            right: 10,
            top: 10,
            bottom: 70
          }
        },
        xAxis: {
          enabled: true,
          scale: "band",
          ticks: {
            enabled: true
          }
        },
        yAxis: {
          enabled: true,
          scale: "linear",
          ticks: {
            enabled: true,
            style: "dashLine",
            format: d3.format(",.0f")
          },
          minZero: true
        },
        tooltip: {
          type: this.chartUnit
        }
      };
      this.dataset = await this.dataset.map(d => { 
        if (d.key == "undefined" || d.key == "null" || d.key == "") d.key = "Sin datos"; 
        return d;
      });

     this.percentageData = this.dataset.map(({key,value}) => ({
        key: key,
        value: this.activeTab.value == "perpetrators" && this.activeOption == 1 ? (value / this.perpetratorTypes.length) * 100 : (value / this.reports.length) * 100
     }))

      const sortBy = this.activeOption == 2 && this.activeTabIndex == 0 ? null : this.activeOption == 3 && this.activeTabIndex == 0 ? null : this.activeOption == 1 && this.activeTabIndex == 3 ? "key" : "value";
      if ((this.activeOption == 3 && this.activeTabIndex == 0) || (this.activeOption == 2 && this.activeTabIndex == 0)) {
        await this.dataset.sort((a,b) => {
          if (isNaN(a.key)) return 1;
          if (isNaN(b.key)) return -1;
          return a.key - b.key;
        })
      }

      var bars = chartModule
        .config(config)
        .bindTo(".chart-" + which + " svg")
        .data({
          raw: this.chartUnit == 'total' ? this.dataset : this.percentageData
        })
        .layer("bars")
        .fill("key")
        .colors(this.colors)
        .sortBy([sortBy]);

      bars.x("key").y("value");

      chartModule.addStyle({
        yAxis: {
          labels: {
            fontSize: "12px",
            fontWeight: 300,
            textColor: "#000000"
          }
        },
        xAxis: {
          labels: {
            fontWeight: 700,
            textColor: "#000000"
          }
        }
      });

      chartModule.draw();
    },
    setData(event = this.options[this.activeTabIndex][0], index = 0) {
      const subject =  this.activeTab.value;
      
      this.activeOption = index;
      if (
        subject == "victimData"
      ) {
        this.dataset = d3.nest()
          .key(d => d[subject][event.value])
          .rollup(v => v.length)
          .entries(this.reports);
      } else if (
        subject == "socioec"
      ) {
        this.dataset = d3.nest()
          .key(d => [event.value] == "condition" ?
          d[subject]['disappearedPerson'][event.value]['isRegisteredCEAV']: 
          [event.value] == "economicDependents" ?
          d[subject][event.value].length :
          d[subject]['disappearedPerson'][event.value])
          .rollup(v => v.length)
          .entries(this.reports);
      } else if (
        subject == "policeReports"
      ) {
        this.dataset = d3.nest()
          .key(d => d[event.value])
          .rollup(v => v.length)
          .entries(this.policeActions);
      } else if (subject == "perpetrators" && this.activeOption == 1) {
        this.dataset = d3.nest()
          .key(d => d[event.value])
          .rollup(v => v.length)
          .entries(this.perpetratorTypes);
      }
      else {
        this.dataset = d3.nest()
          .key(d => d['narrative'][subject][event.value])
          .rollup(v => v.length)
          .entries(this.reports);
      }
      if (this.viewChart) {
        setTimeout(() => {
          this.draw(this.activeTabIndex, event);
        }, 50);
      }
    },
    getTimes() {
      const allMinutes = this.reports.reduce((prev, curr) => {
        return prev + curr.attention ? parseInt(curr.attention.minutes) : 0;
      }, 0);

      this.totalHours = Math.floor(allMinutes / 60);
      this.totalMinutes = allMinutes % 60;

      if (this.reports.length > 0) {
        const average = allMinutes / this.reports.length;
        this.averageHours = Math.floor(average / 60);
        this.averageMinutes = average % 60;
      }
    },
    getReports() {
      this.$store.dispatch("getAllReports");
    },
    downloadChart() {
      d3.selectAll(".switch").style("opacity", 0);
      return new Promise(() => {
        html2canvas(
          d3.select("#downloadable" + this.activeTabIndex).node()
        ).then(canvas => {
          const linkChart = document.createElement("a");
          linkChart.setAttribute("href", canvas.toDataURL("image/jpeg"));
          linkChart.setAttribute("download", "estadisticas.jpeg");
          document.body.appendChild(linkChart);
          linkChart.click();
          d3.selectAll(".switch").style("opacity", 1);
        });
      });
    },
    initialize() {
      this.setData();
      this.getTimes();
    }
  },
  mounted() {
    if (!this.reports.length > 0) {
      this.getReports();
      return setTimeout(() => {
        this.initialize()
      }, 500);
    }
    this.initialize();
  }
};
</script>
<style lang="scss">
#statistics {
  .tabs, .v-tabs {
    max-width: 1300px;
    width: 90%;

    .v-tabs-slider-wrapper {
      display: none;
    }

    .v-slide-group__prev {
      display: none;
    }

    .v-tabs-bar {
      height: 72px !important;
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .v-tabs-bar.v-item-group > * {
      flex: none !important;
      width: auto;
    }

    .v-tabs-bar__content {
      height: 62px !important;
      border: 2px solid #979797;
    }

    .v-tab {
      margin: 10px 0;
      border-right: 2px solid #979797 !important;
      height: 70%;
      text-transform: none;
      font-size: 17px;
    }

    .v-tab:last-of-type {
      border-right: none !important;
    }

    .v-tab--active p {
      color: #fab815;
    }
  }
  .v-window .v-window__container .v-window-item .summary-box,
  .summary-box {
    background-color: #d8d8d8;
    text-align: center;
    font-size: 18px;
    height: 50px;
    align-items: center;
  }
  .v-window .v-window__container .v-window-item .chart-box,
  .chart-box {
    //background-color: #f0f0f0;
    max-width: 1300px !important;
  }
  .v-data-table {
    width: 75%;
  }
  .switch, label {
    align-items: center;
    p {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #414040;
    }
    .input-group.input-group--dirty,
    .input-group--selection-controls {
      width: auto;
    }
  }
  .main-color-button {
    border-radius: 8px;
  }
  .btn-toggle {
    margin-top: 17%;
  }
}
</style>
